import React from 'react';
import { NextPage } from 'next';

import SubHeader from 'components/common/SubHeader';
import PlaceListService from 'components/branch/_place_list';

import { spaceActions } from 'store/space';
import { GetAllBranchesAPI, GetRegionsAPI } from 'api/space';

import { SubHeaderOptions } from 'constants/index';
import { AxiosResponse } from 'axios';

const PlaceList: NextPage = () => {
  return (
    <>
      <SubHeader options={SubHeaderOptions} selected="지점" />
      <PlaceListService />
    </>
  );
};

PlaceList.getInitialProps = async ({ store }) => {
  const branches: AxiosResponse = await GetAllBranchesAPI();
  store.dispatch(
    spaceActions.getBranches({
      ...branches.data,
      region: 'ALL',
    }),
  );

  const regions: AxiosResponse = await GetRegionsAPI();
  store.dispatch(spaceActions.getRegions(regions.data));

  return { query: 'list' };
};

export default PlaceList;
